import { useParams } from "react-router-dom";
import { useGetPronosticV2Query } from "pronosticsv2/api/pronosticv2.api";

export function usePronosticsV2() {
  const { pronosticsV2Id } = useParams<{ pronosticsV2Id: string }>();
  const { data, refetch, isLoading, isError } = useGetPronosticV2Query(
    pronosticsV2Id!,
  );

  return {
    pronosticV2: data,
    refetchPronosticV2: refetch,
    pronosticsV2Loading: isLoading,
    pronosticsV2Error: isError,
  };
}
